export default "__VITE_ASSET__c08a60e2__"